// TODOステータス
export const TODO_STATUS = {
  TODO: 'todo',
  DOING: 'doing',
  DONE: 'done',
} as const;

export const TODO_STATUS_LABELS = {
  [TODO_STATUS.TODO]: 'ToDo',
  [TODO_STATUS.DONE]: '完了',
} as const;

// 優先度（1-3）
export const PRIORITY = {
  HIGH: 1,
  MEDIUM: 2,
  LOW: 3,
} as const;

export const PRIORITY_LABELS = {
  [PRIORITY.HIGH]: 'High',
  [PRIORITY.MEDIUM]: 'Medium',
  [PRIORITY.LOW]: 'Low',
} as const;

// Select/Autocompleteコンポーネント用の優先度オプション
export const PRIORITY_OPTIONS = [
  {label: '選択なし', value: ''},
  {label: 'High', value: PRIORITY.HIGH.toString()},
  {label: 'Medium', value: PRIORITY.MEDIUM.toString()},
  {label: 'Low', value: PRIORITY.LOW.toString()},
] as const;

// 志望度（1-3）
export const ASPIRATION_LEVEL = {
  HIGH: 1,
  MEDIUM: 2,
  LOW: 3,
} as const;

export const ASPIRATION_LEVEL_LABELS = {
  [ASPIRATION_LEVEL.HIGH]: 'High',
  [ASPIRATION_LEVEL.MEDIUM]: 'Medium',
  [ASPIRATION_LEVEL.LOW]: 'Low',
} as const;

// 並び替え
export const TODO_SORT = {
  POSITION: 'position',
  DEADLINE: 'deadline',
  PRIORITY: 'priority',
} as const;

export type TodoSortType = (typeof TODO_SORT)[keyof typeof TODO_SORT];

// 並び替えパラメータ
export const TODO_SORT_PARAMS = {
  // カスタム順: 降順で最新のposition値が上位に表示される
  POSITION: {sortBy: 'position' as const, sortOrder: 'desc' as const},
  // 締切順: 締切が近い順（昇順）
  DEADLINE: {sortBy: 'dueDate' as const, sortOrder: 'asc' as const},
  // 優先度順: 優先度が高い順（昇順: 1=High, 2=Medium, 3=Low）
  PRIORITY: {sortBy: 'priority' as const, sortOrder: 'asc' as const},
} as const;

/**
 * TODOカラムに属するステータスの一覧
 *
 * UIでは2カラム（TODO/DONE）表示だが、内部的にはdoingもtodoとして扱う。
 * ドラッグ&ドロップ時のカラム判定や、フィルタリング処理で使用。
 */
export const TODO_COLUMN_STATUSES = [
  TODO_STATUS.TODO,
  TODO_STATUS.DOING,
] as const;
